import React from 'react';
import { Col, Row, Button } from 'reactstrap';

const Notification = ({ maintenanceBanners, clearUserNotifications }) => {
  return (
    <>
      <Row className="maintenance-notifications">
        <Col>
          <div className="dropdown-arrow" />
          <ul>
            {maintenanceBanners?.map((notify, idx) => {
              return (
                <li key={idx}>
                  <h3>{notify?.frequency} Notification</h3>
                  <p>{notify.description}</p>
                </li>
              );
            })}
            <Button
              onClick={clearUserNotifications}
              color="danger"
              style={{ margin: '0 auto', display: 'block' }}
            >
              Clear Notifications
            </Button>
          </ul>
        </Col>
      </Row>
    </>
  );
};

export default Notification;
